import { render } from "./CourseGallery.vue?vue&type=template&id=881dd024&scoped=true"
import script from "./CourseGallery.vue?vue&type=script&lang=js"
export * from "./CourseGallery.vue?vue&type=script&lang=js"

import "./CourseGallery.vue?vue&type=style&index=0&id=881dd024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-881dd024"]])

export default __exports__